import actionTypes from '../../action-types'

export default (customerProductId, payload, meta, included) => ({
  type: actionTypes.USER_GROUPS.SET_ALL_BADGES,
  payload,
  meta: {
    ...meta,
    customerProductId,
  },
  included,
})
